PJQ.views.invoicing.PayableInvoiceSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-payable-invoice-settings'),
        minWidth: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.invoicesView.userSettings;
    },
    beforeRender: function () {
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];

        this.options.defaultStatusFilter = this.userSettings.get('defaultStatusFilter');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {
            let columns = this.options.invoicesView.dataTable.getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings
        }
    },
    afterRender: function () {
        this.defaultFilterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter-default'),
            isIntChoices: true,
            isMultiple: true,
            defaultValue: this.userSettings.get('defaultStatusFilter'),
            onChange: _.bind(function (value) {
                this.options.defaultStatusFilter = value
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(PJQ.constants.invoicing.view.PAYABLE_INVOICES);
    },
    editCompanySettings: function () {
        this.userSettings = new PJQ.models.invoicing.PayableInvoiceUserSettings(null, {
            forCompany: true
        });
        this.userSettings.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
            this.$('div.rows-per-page').show();
        }
        else
            this.$('div.rows-per-page').hide();

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.userSettings.set('defaultStatusFilter', this.options.defaultStatusFilter);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        }
                        else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.userSettings.save(null, {
            success: _.bind(function () {
                fnOnSave();
            }, this)
        });
    },
});